import { defineComponent as _defineComponent } from 'vue'
import { ref, useAttrs } from 'vue'
import type { Ref } from 'vue'
import useGlobal from '../../composables/useGlobal'
import { userKeySwap } from '@/services/order.service'
import executeWithRefresh from '@/composables/useRefresher'

export default /*#__PURE__*/_defineComponent({
  __name: 'KeyGenModal',
  setup(__props, { expose }) {
  expose();

const { $t } = useGlobal()
const attrs = useAttrs()

async function swapKey() {
  try {
    const { data: { access, refresh } } = (await executeWithRefresh(userKeySwap, null, {key: attrs.initial.key}, null))
    attrs.initial.getList()
    attrs.close()
  } catch(e) {
    return Promise.reject(e)
  }
}



  
const __returned__ = { $t, attrs, swapKey, ref, useAttrs, useGlobal, userKeySwap, executeWithRefresh }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})